import React, { useState } from 'react'
import Circle from './Circle'

import './circleOfFifths.css'

const majorScale = {
	'F': ['F', 'Gm', 'Am', 'Bb', 'C', 'Dm', 'E'],
	'C': ['C', 'Dm', 'Em', 'F', 'G', 'Am', 'B'],
	'G': ['G', 'Am', 'Bm', 'C', 'D', 'Em', 'F#'],
	'D': ['D', 'Em', 'F#m', 'G', 'A', 'Bm', 'C#'],
	'A': ['A', 'Bm', 'C#m', 'D', 'E', 'F#m', 'G#'],
	'E': ['E', 'F#m', 'G#m', 'A', 'B', 'C#m', 'D#'],
	'B': ['B', 'C#m', 'D#m', 'E', 'F#', 'G#m', 'A#'],
	'F#': ['F#', 'G#m', 'A#m', 'B', 'C#', 'D#m', 'E#'],
	'Bb': ['Bb', 'Cm', 'Dm', 'Eb', 'F', 'Gm', 'Ab'],
	'Eb': ['Eb', 'Fm', 'Gm', 'Ab', 'Bb', 'Cm', 'D'],
	'Ab': ['Ab', 'Bbm', 'Cm', 'Db', 'Eb', 'Fm', 'G'],
	'Db': ['Db', 'Ebm', 'Fm', 'Gb', 'Ab', 'Bbm', 'C']
}

const minorScale = {
	'D': ['Dm', 'E', 'F', 'Gm', 'Am', 'Bb', 'C'],
	'A': ['Am', 'B', 'C', 'Dm', 'Em', 'F', 'G'],
	'E': ['Em', 'F#', 'G', 'Am', 'Bm', 'C', 'D'],
	'B': ['Bm', 'C#', 'D', 'Em', 'F#m', 'G', 'A'],
	'F#': ['F#m', 'G#', 'A', 'Bm', 'C#m', 'D', 'E'],
	'Bb': ['Bbm', 'C', 'Db', 'Ebm', 'Fm', 'Gb', 'Ab'],
	'Eb': ['Ebm', 'F', 'Gb', 'Abm', 'Bbm', 'Cb', 'Db'],
	'Ab': ['Abm', 'Bb', 'Cb', 'Dbm', 'Ebm', 'Fb', 'Gb'],
	'Db': ['Dbm', 'Eb', 'Fb', 'Gbm', 'Abm', 'Bb', 'C'],
	'F': ['Fm', 'G', 'Ab', 'Bbm', 'Cm', 'Db', 'Eb'],
	'C': ['Cm', 'D', 'Eb', 'Fm', 'Gm', 'Ab', 'B'],
	'G': ['Gm', 'A', 'Bb', 'Cm', 'Dm', 'Eb', 'F'],
}

const CircleOfFifths = (props: {
	scale: any,
	onChange: (scale: any) => void,
}) => {

	const {
		scale,
		onChange
	} = props

	const [open, setOpen] = useState(false)

	const [selectedRoot, setSelectedRoot] = useState('C')
	const [selectedCircle, setSelectedCircle] = useState('outer')

	return (
		<div id='circleoffifths' style={{ display: 'flex', justifyContent: 'center', transform: 'scale(1.2)' }}>
			<Circle
				scale={scale}
				onChange={(selectedRoot) => { setSelectedRoot(selectedRoot); setSelectedCircle('outer') }}
				onOpen={() => setOpen(!open)}
				open={open}
				roots={Object.keys(majorScale)}
				selectedRoot={selectedCircle !== 'inner' ? selectedRoot : ''}
			/>
			<Circle
				scale={scale}
				onChange={(selectedRoot) => { setSelectedRoot(selectedRoot); setSelectedCircle('inner') }}
				onOpen={() => setOpen(!open)}
				open={open}
				isInset
				roots={Object.keys(minorScale)}
				selectedRoot={selectedCircle === 'inner' ? selectedRoot : ''}
			/>
		</div>
	)
}

export default CircleOfFifths
